export const DEFAULT_DISABLE_CLOCK_SKEW_CORRECTION = false;
